module.exports = __webpack_public_path__ + "img/recessionprooffunding-white-text-only-powered.7bc79862.png";